var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"r-image-button"},[_c('div',{staticClass:"bordered"},[_c('img',{attrs:{"src":require('@/assets/images/' + _vm.src)}}),_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }